// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"13006603","166":"57e745a9","185":"97f2b0ec","406":"d24cd463","558":"183cde7c","584":"548d9126","620":"4da02ae8","993":"aa7d2e26","994":"14daae7a"}[chunkId] + ".chunk.js";
};